export class Candidature {
    constructor(
        public id?: number,
        public nomPatronymique?: string,
        public nomUsuel?: string,
        public prenom?: string,
        public prenom2?: string,
        public dateNaissance?: any,
        public telephoneFixe?: string,
        public telephonePortable?: string,
        public bacTypeEtablissement?: string,
        public bacAnnee?: number,
        public bac?: string,
        public bacMention?: string,
        public bacPays?: string,
        public bacDept?: string,
        public bacEtab?: number,
        public bacEtablissementAutre?: string,
        public bacVille?: string,
        public paysNaissance?: string,
        public villeNaissance?: string,
        public deptNaissance?: string,
        public paysNationalite?: string,
        public paysNationalite2?: string,
        public civilite?: string,
        public navigator?: string,
        public userId?: number,
        public ines?: string,
        public bourse?: boolean,
        public bacSpec1LibelleCourt?: string,
        public bacSpec2LibelleCourt?: string
    ) { }

    static areSpecialitesBacObligatoires(candidature: Candidature) {
        return candidature.bacTypeEtablissement && candidature.bacTypeEtablissement !== 'ETRANGER'
            && candidature.bacAnnee && candidature.bacAnnee >= 2021;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature.model.ts